import type { MessageMenuItem } from "../types";

export const messageMenuCache: Record<string, MessageMenuItem[]> = {};

export function clearMessageMenuCache(): void {
  for (const key of Object.keys(messageMenuCache)) {
    delete messageMenuCache[key];
  }
}
